import { createStore } from 'vuex'
import axios from 'axios';

export default createStore({
  state: {
    kaart: null,
    gemeenteSelected: null,
    buurtSelected: null,
    gemeentenAutocomplete: null,
    userLocation: null
  },
  mutations: {
    SAVE_NL(state, data) {
      state.kaart = data;
    },

    SAVE_LIJST (state, data) {
      let features = data.gemeenten;

      features.sort((a,b) => {
        if(a.properties.GM_NAAM < b.properties.GM_NAAM) { return -1; }
        if(a.properties.GM_NAAM > b.properties.GM_NAAM) { return 1; }
        return 0;
      });

      state.gemeentenAutocomplete = features.map((d, index) => {
        return {label: d.properties.GM_NAAM, value: index, code: d.properties.GM_CODE}
      });
    }, 

    SAVE_GEMEENTE(state, data) {
      state.gemeenteSelected = data;
    },

    SET_BUURT(state, buurt) {
      state.buurtSelected = buurt;
    },

    SET_LOCATION(state, data) {
      state.userLocation = data;
    }
  },
  getters: {    
    gemeenteSelected(state) {
      return state.gemeenteSelected;
    },

    buurtSelected(state) {
      return state.buurtSelected;
    }
  },
  actions: {
    loadNL({ commit, state }, gemeente) {
      return new Promise((resolve, reject) => { 
        axios
          .get(process.env.BASE_URL + "data/gemeenten/gemeentelijst.json")
          .then(result => {
            commit("SAVE_NL", result.data);
            commit("SAVE_LIJST", result.data);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },

    loadGemeente({ commit, state }, gemeente) {
      return new Promise((resolve, reject) => { 
        axios
          .get(process.env.BASE_URL + "data/gemeenten/" + gemeente + ".json")
          .then(result => {
            commit("SAVE_GEMEENTE", result.data);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },

    updateBuurt({ commit }, buurt) {
      commit("SET_BUURT", buurt);
    },

    updateUserLoc({ commit }, arr) {
      commit("SET_LOCATION", arr);
    },
  },
  modules: {

  }
})
